import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AudioSelectButton } from "@livekit/react-components";
import logo from "./icons/logo.webp";

export const PreJoinPage = () => {
  const navigate = useNavigate();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [audioEnabled, setAudioEnabled] = useState(true);
  const [isConnecting, setIsConnecting] = useState(false);

  const canConnect = Boolean(firstName.trim() && lastName.trim());

  const connectToRoom = async () => {
    if (!canConnect || isConnecting) return;
    setIsConnecting(true);

    try {
      const username = `${firstName.trim()} ${lastName.trim()}`;

      const res = await fetch("https://voice-dev.deepmine.ir/token-dev/generate_token", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          username
        })
      });
      console.log(username);

      console.log("Status:", res.status);

      const data = await res.json();
      console.log("Response:", data.room_name);

      if (!data?.token || !data?.room_name) {
        alert("خطا در اتصال");
        return;
      }

      sessionStorage.setItem("room_name", data.room_name);


      const serverUrl =
        data.room_name.url ||
        data.room_name.server_url ||
        "wss://lk-dev.deepmine.ir";

      navigate(
        `/room?room_name=${encodeURIComponent(
          data.room_name
        )}&project=dev&url=${encodeURIComponent(
          serverUrl
        )}&token=${data.token}&audioEnabled=${audioEnabled ? "1" : "0"}`
      );

      console.log("url:", navigate);

    } catch (err) {
      console.error(err);
      alert("خطا در اتصال به سرور");
    } finally {
      setIsConnecting(false);
    }
  };

  return (
    <div className="prejoin-container">
      <div className="prejoin-card">
        <div className="prejoin-orb">
          <div className="orb-mini">
            <img
              src={logo}
              alt="logo"
              className="brand-logo"
              draggable={false}
            />
          </div>
        </div>

        <header className="prejoin-header">
          <h1>دستیار صوتی شاتل</h1>
          <p>
            برای شروع مکالمه، نام و نام خانوادگی خود را وارد کنید
          </p>
        </header>

        <div className="prejoin-form">
          <input
            placeholder="نام"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />

          <input
            placeholder="نام خانوادگی"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
        </div>

        <div className="mic-row">
          <AudioSelectButton
            isMuted={!audioEnabled}
            onClick={() => setAudioEnabled((v) => !v)}
          />

          <span className={audioEnabled ? "mic-on" : "mic-off"}>
          {audioEnabled
            ? "میکروفون فعال است"
            : "میکروفون خاموش است"}
        </span>
        </div>

        <button
          className="primary-btn"
          disabled={!canConnect || isConnecting}
          onClick={connectToRoom}
        >
          {isConnecting
            ? "در حال اتصال..."
            : "ورود"}
        </button>

        <footer className="prejoin-footer">
          تمامی حقوق این سامانه متعلق به
          <b> شاتل </b>
          می‌باشد.
        </footer>
      </div>
    </div>
  );
};

